import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const ResourceOutsource = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  const scrollToSection = (id) => {
    const targetElement = document.getElementById(id);
    window.scrollTo({
      top: targetElement.offsetTop - 60, // Adjust this value to add space above the section
      behavior: "smooth",
    });
  };

  return (
    <div>
      <section className="banner">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h6 className="banner-subtitle">Services / Resource Outsourcing</h6>
          <hr />
          <h1 className="banner-title">
            Empower Your Business with Expert Talent
          </h1>
          <button className="banner-button mt-3">
            Contact Us <span className="arrow">→</span>
          </button>
        </div>
        <img
          src="./assets/img/3010.png"
          alt="Banner Background"
          className="banner-image"
        />
      </section>

      <section id="about_pg" className="p_3">
        <div className="container-xl">
          <div className="row about_pg1">
            <div className="col-md-12">
              <div className="about_pg1l mt-5">
                <h6 className="col_yell">
                  Why Choose Our Resource Outsourcing?
                </h6>
                <h2 className="mt-3 mb-3">
                  Tailored Outsourcing Solutions for Your Business Needs
                </h2>
                <p>
                  At <strong>DataFluent Analytics</strong>, we specialize in
                  providing businesses with highly skilled professionals through
                  resource outsourcing. Whether you're a growing startup or an
                  established enterprise, we connect you with the right talent
                  at the right time.
                </p>
                <p>
                  Our solutions help you scale efficiently while reducing
                  overhead costs, ensuring that you can focus on your core
                  operations while we handle resource management.
                </p>
              </div>
            </div>

            {/* <div className="col-md-4">
              <div className="about_pg1r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <a href="#">
                      <img
                        src="https://img.freepik.com/free-photo/html-css-collage-concept-with-person_23-2150062008.jpg"
                        className="w-100"
                        alt="Empowering Decisions"
                      />
                    </a>
                  </figure>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      <section id="process" class="p-5 bg-black text-white">
        <div class="container-xl">
          <h2 class="text-center mb-5">Our Process</h2>
          <div class="row text-center">
            <div class="col-md-4">
              <div class="process-step p-4 shadow-sm rounded">
                <div class="icon mb-4" style={{ color: "#007bff" }}>
                  <i class="fa fa-clipboard-check fa-2x"></i>
                </div>
                <h3 class="mb-3">Consultation</h3>
                <p>
                  We understand your business needs and match you with the right
                  talent to drive your goals forward.
                </p>
              </div>
            </div>

            <div class="col-md-4">
              <div class="process-step p-4 shadow-sm rounded">
                <div class="icon mb-4" style={{ color: "#28a745" }}>
                  <i class="fa fa-users fa-2x"></i>
                </div>
                <h3 class="mb-3">Selection</h3>
                <p>
                  We handpick professionals that align with your company’s
                  requirements, ensuring skill and experience fit.
                </p>
              </div>
            </div>

            <div class="col-md-4">
              <div class="process-step p-4 shadow-sm rounded">
                <div class="icon mb-4" style={{ color: "#ffc107" }}>
                  <i class="fa fa-check-circle fa-2x"></i>
                </div>
                <h3 class="mb-3">Onboarding</h3>
                <p>
                  Once selected, we onboard the professionals, ensuring a smooth
                  integration with your existing team and processes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="services_benefits" class="py-5">
        <div class="container-xl">
          <h2 class="text-center mb-4">Key Benefits</h2>
          <p class="text-center mb-5">
            Discover the advantages of partnering with us to meet your resource
            outsourcing needs.
          </p>
          <div class="row">
            <div class="col-md-4 mb-4">
              <div class="service-item p-4 shadow-sm rounded bg-white d-flex align-items-start">
                <div class="icon me-3 text-primary">
                  <i class="fa fa-users fa-2x"></i>
                </div>
                <div>
                  <h4 class="mb-2">Access to Top Talent</h4>
                  <p>
                    We provide you with professionals skilled in IT, marketing,
                    design, and more, offering expertise across multiple
                    domains.
                  </p>
                </div>
              </div>
            </div>

            <div class="col-md-4 mb-4">
              <div class="service-item p-4 shadow-sm rounded bg-white d-flex align-items-start">
                <div class="icon me-3 text-primary">
                  <i class="fa fa-clock fa-2x"></i>
                </div>
                <div>
                  <h4 class="mb-2">Save Time and Resources</h4>
                  <p>
                    Focus on your core business activities while we handle the
                    recruitment, training, and management of outsourced
                    resources.
                  </p>
                </div>
              </div>
            </div>

            <div class="col-md-4 mb-4">
              <div class="service-item p-4 shadow-sm rounded bg-white d-flex align-items-start">
                <div class="icon me-3 text-primary">
                  <i class="fa fa-cogs fa-2x"></i>
                </div>
                <div>
                  <h4 class="mb-2">Scalable Solutions</h4>
                  <p>
                    Scale your team up or down as needed, ensuring you have the
                    right resources at every stage of your project.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="serv_h" className="p_3">
        <div className="container-fluid" style={{ padding: 40 }}>
          <div className="row serv_h1 mb-4 text-center">
            <div className="col-md-12">
              <div className="serv_h1l">
                <h3>Our Clients</h3>
                {/* <p className="mb-0">Trusted by leading innovators worldwide.</p> */}
              </div>
            </div>
          </div>

          <div className="my-swiper-container">
            <Swiper
              modules={[]}
              spaceBetween={16}
              loop={true}
              breakpoints={{
                320: {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 16,
                },
                1024: {
                  slidesPerView: 4,
                  spaceBetween: 16,
                },
                1200: {
                  slidesPerView: 5,
                  spaceBetween: 20,
                },
              }}
            >
              {/* React.js */}
              <SwiperSlide>
                <img
                  src="./assets/img/ict.png"
                  alt="React.js"
                  style={{
                    width: "120px",
                    height: "80px",
                    objectFit: "contain",
                    margin: "auto",
                  }}
                />
              </SwiperSlide>

              {/* python */}
              <SwiperSlide>
                <img
                  src="./assets/img/upay.png"
                  alt="upay"
                  style={{
                    width: "120px",
                    height: "80px",
                    objectFit: "contain",
                    margin: "auto",
                  }}
                />
              </SwiperSlide>

              <SwiperSlide>
                <img
                  src="./assets/img/ngdt.png"
                  alt="Client Logo 4"
                  style={{
                    width: "120px",
                    height: "80px",
                    objectFit: "contain",
                    margin: "auto",
                  }}
                />
              </SwiperSlide>

              <SwiperSlide>
                <img
                  src="https://www.jobplant.com.au/images/job-plant_color.png"
                  alt="Client Logo 6"
                  style={{
                    width: "120px",
                    height: "80px",
                    objectFit: "contain",
                    margin: "auto",
                  }}
                />
              </SwiperSlide>

              <SwiperSlide>
                <img
                  src="./assets/img/hive4work.png"
                  alt="Client Logo 6"
                  style={{
                    width: "120px",
                    height: "80px",
                    objectFit: "contain",
                    margin: "auto",
                  }}
                />
              </SwiperSlide>
            </Swiper>

            <div className="my-swiper-button-prev"></div>
            <div className="my-swiper-button-next"></div>
          </div>
        </div>
      </section>

      <hr />

      <section id="serv_h" className="p_3">
        <div className="container-xl">
          <div className="row serv_h3 mt-4  pt-5 pb-5 mx-0 px-4">
            <div className="col-md-8">
              <div className="serv_h3l">
                {/* <h6 className="">Benefits</h6> */}
                <h2 className="">Ready to Scale Your Team?</h2>
                <p className="mt-3">
                  Let's discuss how our resource outsourcing services can help
                  you grow and achieve business success.
                </p>
                <button className="banner-button mt-3">
                  <Link
                    to="/contact"
                    className="text-decoration-none text-white"
                  >
                    Let’s talk <span className="arrow">→</span>
                  </Link>
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serv_h3r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <Link to="/contact">
                      <img
                        src="https://img.freepik.com/free-photo/medium-shot-two-colleagues-discussing-business-office_1098-17855.jpg"
                        className="w-100"
                        alt="Help"
                      />
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ResourceOutsource;
